import React from "react";

export const keepOnlyAlphaSpace = (str: string): string => {
  return str.replace(/[^a-zA-Z\s]*/g, "");
};

export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const startWithVowel = (str: string): boolean => {
  return str !== "" && "aeiou".includes(str.charAt(0).toLowerCase());
};

export const textOrEmpty = (text?: string): string => {
  return text ? text : "";
};

export const processStringTag = (element?: string): string => {
  if (!element) return "";
  const tempContainer = document.createElement("div");
  //Remove extra \n to solve the space problem when ul and ol are close together
  element = element
    ?.replaceAll("<br>", "\n")
    .replaceAll("<ol>\n", "<ol>")
    .replaceAll("</ol>\n", "</ol>")
    .replaceAll("<ul>\n", "<ul>")
    .replaceAll("</ul>\n", "</ul>");
  tempContainer.innerHTML = element;
  return tempContainer.innerText;
};

export const processFullContentStringTag = (
  element?: string,
  isFullcontent = false
): string | React.ReactElement => {
  if (!element) return "";

  if (!isFullcontent) {
    return processStringTag(element);
  }

  // viewFullcontent modal needs available hyperlinks.
  const createMarkup = { __html: element };
  return React.createElement("div", {
    dangerouslySetInnerHTML: createMarkup
  });
};

export const handleAIWriterRequestSuggestions = (suggestion: string) => {
  const closings = [
    "sincerely,",
    "kind regards,",
    "warm regards,",
    "best regards,",
    "thank you for your time,",
    "thank you,",
    "regards,",
    "yours faithfully,",
    "yours sincerely,",
    "with appreciation,",
    "with gratitude,"
  ];

  const lowerText = suggestion.toLowerCase();
  for (const phrase of closings) {
    const index = lowerText.lastIndexOf(phrase);
    if (index !== -1) {
      return suggestion.slice(0, index).trim();
    }
  }

  return suggestion.trim();
};
